import { makeStyles, tokens } from "@fluentui/react-components";
export const BUTTON_WIDTH = 80;
export const TH_PADDING = 12;

export const useRiskAnalysisTableStyles = makeStyles({
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",

    "& thead": {
      backgroundColor: tokens.colorBrandBackground,
      "& th": {
        color: tokens.colorNeutralForegroundStaticInverted,
      },

      "& th:not(:first-child)": {
        borderLeft: `2px solid ${tokens.colorNeutralStroke1}`,
        paddingLeft: `${TH_PADDING}px`,
      },
    },

    "& tbody": {
      "& tr td": {
        fontSize: "12px",
      },
    },
  },
  statusBadge: {
    padding: "4px 12px",
    borderRadius: "4px",
    fontWeight: "500",
    border: "none",
    color: tokens.colorNeutralForeground1Static,
    "&:hover": {
      backgroundColor: "inherit",
      color: tokens.colorStrokeFocus1,
    },
  },
  redStatus: {
    backgroundColor: "rgb(253 201 181)",
  },
  yellowStatus: {
    backgroundColor: "rgb(251 251 184)",
  },
  greenStatus: {
    backgroundColor: "rgb(208 251 184)",
  },
  defaultStatus: {
    backgroundColor: "rgb(221 221 221)",
  },
  summaryContainer: {
    backgroundColor: tokens.colorNeutralBackground2,
    padding: "16px",
    margin: "8px 0",
    borderRadius: "4px",
    "& h3": {
      margin: "0 0 8px 0",
      fontWeight: "600",
    },
    "& ul": {
      margin: "0",
      paddingLeft: "20px",
    },
    "& li": {
      marginBottom: "4px",
    },
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    minWidth: "auto",
    maxWidth: `calc(100% - ${TH_PADDING}px - 8px)`,

    "& button": {
      width: `${BUTTON_WIDTH}px`,
    },
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dialogTitleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    fontSize: "16px",
  },
  promptContent: {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
  },
  fullReportListItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  fullReportListItemTitle: {
    textDecoration: "underline",
  },
  navigationControls: {
    marginBottom: "12px",
  },
  navigationButtons: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  warningBadgeContainer: {
    minWidth: "fit-content",
    padding: "0px",
  },
  warningBadge: {
    border: `1px solid ${tokens.colorStatusWarningBorder1}`,
    "& span": {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },
  },
  spinner: {
    "& label": {
      color: tokens.colorNeutralForeground1,
      fontSize: "12px",
    },
  },
  statusBadgeContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  canceledCell: {
    textDecoration: "italic",
    fontSize: "12px",
    color: tokens.colorNeutralForeground4,
  },
  textCenter: {
    textAlign: "center",
  },
  refreshButton: {
    marginLeft: "8px",
  },
  fallbackRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  popover: {
    marginTop: "4px",
  },
  popoverTitle: {
    padding: "8px",
    marginBottom: "16px",
    borderRadius: "4px",
    backgroundColor: tokens.colorBrandBackground,
  },
});
